import React from 'react';

export function GetEanSearch(jumpTarget, eanInfo) {
  let defaultEan = '';
  let eanSearchParam = '';
  let eanItem = <></>;

  try {
    let winAny: any = window;
    let location = winAny.historyHelper.memory.location;
    if (location.search != '') {
      let urlParams = new URLSearchParams(location.search);
      defaultEan = urlParams.get('ean') ?? '';
      eanSearchParam = 'ean=' + defaultEan;
    }
  } catch (error) {}

  if (eanInfo != null) {
    eanItem = (
      <>
        <a
          href={eanInfo.Sortiment + '/' + eanInfo.products_id + '-/'}
          target="_blank"
        >
          <img
            src={
              'https://media.moluna.de/images/bilder/' + eanInfo.products_image
            }
            style={{
              width: '70px',
              marginBottom: '-30px',
              marginRight: '10px',
            }}
            draggable="false"
          ></img>
          {eanInfo.Bezeichnung + ' | ' + eanInfo.Verlag}
        </a>
      </>
    );
  } else {
    //debugger;
  }
  let inputBar = (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        let targetAny: any = e.target;
        let ean = targetAny.children[0].value.trim().replaceAll('-', '');
        let winAny: any = window;
        if (ean != '') {
          winAny.historyHelper.memory.push(jumpTarget + '?ean=' + ean, null);
        } else {
          winAny.historyHelper.memory.push(jumpTarget, null);
        }
      }}
    >
      <b>ISBN/EAN suchen: </b>
      <input className="EAN_SEARCH" defaultValue={defaultEan} />
      {defaultEan != '' ? eanItem : null}
    </form>
  );
  let retItem = { gui: <>{inputBar}</>, eanSearchParam: eanSearchParam };
  return retItem;
}
